import ScrollBooster from 'scrollbooster';

$(function () {
    let App = window.App;
    App.product = {};

    let $quantityFavoritesProducts = $('.js-quantity-favorites-products');

    App.product.updateFavoriteStatus = function (e, $this, modelId) {
        e.preventDefault();

        let active = $this.hasClass('active');

        if ($this.hasClass('pending')) {
            return false;
        }

        if (active && $this.data('no-removal')) {
            $(location).attr('href', $quantityFavoritesProducts.parent().attr('href'));
            return false;
        }

        $.ajax({
            type: 'POST',
            url: active ? '/favorites/remove' : '/favorites/add',
            data: {
                model_id: modelId,
            },
            dataType: 'json',
            beforeSend: function () {
                $this.addClass('pending');
            },
            success: function (response) {
                App.analytics.sendAnalyticsGoal('serdce');

                if (response.hasOwnProperty('total')) {
                    App.updateCounters(null, null, response.total);
                }

                if ($this.attr('data-favorite') !== undefined) {
                    $(`button[data-favorite=${$this.data('favorite')}]`).toggleClass('active', !active);
                } else {
                    $this.toggleClass('active', !active);
                }

                if (response.hasOwnProperty('modal_view')) {
                    $('footer').before(response.modal_view);
                    App.modal.open($('#addedToFavoritesModal'));
                    window.App.lazyImageLoading();
                }
            },
            complete: function () {
                $this.removeClass('pending');
            }
        });
    }

    let $quantityProductsCompared = $('#quantityProductsCompared'),
        $referencesToCompareProducts = $quantityProductsCompared.parent();

    App.product.updateComparisonStatus = function (e, $this, modelId, status = undefined) {
        e.preventDefault();

        let active = $this.hasClass('active');

        if ($this.hasClass('pending')) {
            return false;
        }

        if (active && $this.data('no-removal')) {
            $(location).attr('href', $quantityProductsCompared.attr('href'));
            return false;
        }

        if (status !== undefined) {
            active = status;
        }

        $.ajax({
            type: 'POST',
            url: active ? '/compare/remove' : '/compare/add' ,
            data: {
                model_id: modelId,
            },
            dataType: 'json',
            beforeSend: function () {
                $this.addClass('pending');
            },
            success: function (response) {
                App.analytics.sendAnalyticsGoal('zhostkoct');

                if (response.hasOwnProperty('total')) {
                    App.updateCounters(null, response.total);
                }

                if (response.hasOwnProperty('link')) {
                    $referencesToCompareProducts.attr('href', response.link);
                }

                if ($this.attr('data-comparison') !== undefined) {
                    $(`button[data-comparison=${$this.data('comparison')}]`).toggleClass('active', !active);
                } else {
                    $this.toggleClass('active', !active);
                }

                if (response.hasOwnProperty('modal_view')) {
                    $('footer').before(response.modal_view);
                    App.modal.open($('#addedToComparisonModal'));
                    window.App.lazyImageLoading();
                }
            },
            complete: function () {
                $this.removeClass('pending');
            }
        });
    }

    let $quantityProductsInStiffnessComparison = $('#quantityProductsInStiffnessComparison'),
        $referencesToStiffnessCompare = $('.js-compare-param-link');

    App.product.updateStiffnessComparisonStatus = function ($this, modelId) {
        let active = $this.hasClass('active');

        if ($this.hasClass('pending')) {
            return false;
        }

        if (active && $this.data('no-removal')) {
            $(location).attr('href', $quantityProductsInStiffnessComparison.parent().attr('href'));
            return false;
        }

        $.ajax({
            type: 'POST',
            url: active ? '/compare_param/remove' : '/compare_param/add',
            data: {
                model_id: modelId,
            },
            dataType: 'json',
            beforeSend: function () {
                $this.addClass('pending');
            },
            success: function (response) {
                if (response.hasOwnProperty('total')) {
                    App.updateCounters(response.total);
                }

                if (response.hasOwnProperty('link')) {
                    $referencesToStiffnessCompare.attr('href', response.link);
                }

                $this.toggleClass('active', !active);

                if (response.hasOwnProperty('modal_view')) {
                    $('footer').before(response.modal_view);
                    App.modal.open($('#addedToStiffnessComparisonModal'));
                    window.App.lazyImageLoading();
                }
            },
            complete: function () {
                $this.removeClass('pending');
            }
        });
    }

    $(document).on({
        mouseenter: function () {
            if ($(this).hasClass('scroll-booster-init') || $(this).find('.card-standard').hasClass('mini')) {
                return false;
            }

            if ($(this).find('.thumbnails').length) {
                new ScrollBooster({
                    viewport: $(this).find('.viewport')[0],
                    content: $(this).find('.viewport .content')[0],
                    direction: "vertical",
                    scrollMode: "transform"
                });
            }

            $(this).addClass('scroll-booster-init');
        }
    }, '.card-standard-wrapper');

    $(document).on('click', '.card-standard .thumbnails img', function (e) {
        e.preventDefault();

        let $thumbnails = $(this).closest('.thumbnails').find('img.active');
        $thumbnails.removeClass('active');

        $(this).addClass('active');
        $(this).closest('.card-standard').find('.main-img').attr('src', $(this).attr('src'));
    });
});